// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaGlobe } from "react-icons/fa";
// import "bootstrap/dist/css/bootstrap.min.css";

// const styles = {
//   section: {
//     padding: "60px 15px",
//     background: "#f5f9f8",
//     fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
//     color: "#333",
//   },
//   card: {
//     backgroundColor: "#fff",
//     borderRadius: "16px",
//     padding: "30px 25px",
//     boxShadow: "0 8px 20px rgba(0, 0, 0, 0.07)",
//     marginBottom: "30px",
//   },
//   subheader: {
//     color: "#8f0909ff",
//     fontWeight: "600",
//     fontSize: "1.6rem",
//     marginBottom: "15px",
//     borderBottom: "2px solid #8f0909ff",
//     paddingBottom: "6px",
//     display: "inline-block",
//   },
//   icon: {
//     color: "#f06b43ff",
//     marginRight: "10px",
//     verticalAlign: "middle",
//     fontSize: "1.3rem",
//   },
//   text: {
//     fontSize: "1.05rem",
//     lineHeight: 1.6,
//     color: "#444",
//     marginBottom: "15px",
//   },
//   list: {
//     listStyleType: "disc",
//     paddingLeft: "1.5rem",
//     lineHeight: 1.75,
//     color: "#444",
//     fontSize: "1.05rem",
//   },
//   link: {
//     color: "#8f0909ff",
//     fontWeight: "600",
//     textDecoration: "none",
//   },
// };

// const AboutUs = () => {
//   return (
//     <div style={styles.section}>
//       <Container>
//         <Row className="gy-4">
//           {/* Left Column - About the company */}
//           <Col md={6}>
//             <div style={styles.card}>
//               <h4 style={styles.subheader}>About Radheshyam Travels</h4>
//               <p style={styles.text}>
//                 Radheshyam Travels offers comprehensive services covering all aspects of travel planning
//                 and execution, from ground transportation to complete packaged tours.
//               </p>
//               <p style={styles.text}>
//                 They are a one-stop shop for both domestic and international trips, known for creating
//                 seamless travel experiences. Destinations include Gujarat, Rajasthan, South India
//                 (Bangalore, Mysore, Kerala), North India (Himachal Pradesh, Kashmir), Nepal, Sikkim/Darjeeling,
//                 Goa, and international destinations like Dubai and Singapore.
//               </p>
//               <p style={styles.text}>
//                 A prominent offering is the Chardham Yatra, where they provide specialized services
//                 like in-house hill-experienced drivers, guaranteed medical support, and VIP darshan assistance.
//               </p>
//             </div>
//           </Col>

//           {/* Right Column - Services and Contact */}
//           <Col md={6}>
//             <div style={styles.card}>
//               <h4 style={styles.subheader}>Services & Transportation</h4>
//               <ul style={styles.list}>
//                 <li>Tour Packages: Domestic & international customizable tours.</li>
//                 <li>Bus Services: Fleet of 44+ buses, online ticket booking available.</li>
//                 <li>Car & Coach Rentals: Private cars & tempo travellers for tours.</li>
//                 <li>Air & Rail Ticketing: Domestic and international bookings.</li>
//                 <li>Owned Hotels/Resorts: Narayan Palace, Pinaki Resort, etc.</li>
//                 <li>Conference & Corporate Tours for specialized needs.</li>
//               </ul>

//               <h4 style={{ ...styles.subheader, marginTop: "30px" }}>Contact Info</h4>
//               <p>
//                 <FaMapMarkerAlt style={styles.icon} />
//                 102, 104, Time Square Complex, Nr. Pariseema Complex, C.G. Road, Navrangpura, Ahmedabad, Gujarat 380006
//               </p>
//               <p>
//                 <FaPhone style={styles.icon} />
//                 079 2644 3778 | All-India: 08069247359 (Ext: 046)
//               </p>
//               <p>
//                 <FaEnvelope style={styles.icon} />
//                 info@radheshyamtravels.com | booking@radheshyamtravels.com
//               </p>
//               <p>
//                 <FaGlobe style={styles.icon} />
//                 <a href="https://www.radheshyamgroup.com/" target="_blank" rel="noopener noreferrer" style={styles.link}>
//                   www.radheshyamgroup.com
//                 </a>
//               </p>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default AboutUs;


import React from "react";
import { Container, Row, Col, Badge, Image } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaChevronRight } from "react-icons/fa";

const AboutUs = ({ webSettings }) => {
  const office = webSettings?.ourOffice?.[0];

  const styles = {
    wrapper: {
      backgroundColor: "#fcfcfd",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#1a1a1a",
      overflow: "hidden"
    },
    heroSection: {
   // --- BACKGROUND IMAGE ADDED HERE ---
      background: `linear-gradient(rgba(58, 57, 121, 0.8), rgba(10, 29, 55, 0.9)), 
 
                   url('https://images.unsplash.com/photo-1488646953014-85cb44e25828?q=80&w=1935&auto=format&fit=crop')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed", // Parallax effect
      padding: "140px 0 180px",
      clipPath: "ellipse(110% 60% at 50% 40%)",
      color: "white",
      textAlign: "center",
      position: "relative"
    },
    floatingCard: {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      backdropFilter: "blur(10px)",
      borderRadius: "24px",
      padding: "40px",
      boxShadow: "0 20px 40px rgba(0,0,0,0.05)",
      marginTop: "-100px",
      border: "1px solid rgba(255,255,255,0.3)"
    },
    policyPill: {
      background: "#fff",
      borderRadius: "16px",
      padding: "20px",
      marginBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
      border: "1px solid #f1f1f1",
      transition: "transform 0.2s ease"
    },
    sectionTitle: {
      fontSize: "2.5rem",
      fontWeight: "800",
      letterSpacing: "-1px",
      marginBottom: "20px",
      color: "#1a1a1a"
    }
  };

  return (
    <div style={styles.wrapper}>
      {/* --- HERO --- */}
      <section style={styles.heroSection}>
        <Container>
          <Badge pill bg="light" text="danger" className="mb-3 px-3 py-2 fw-bold">
            ESTABLISHED TRAVEL EXCELLENCE
          </Badge>
          <h1 style={{ fontSize: "4rem", fontWeight: "900" }}>Radheshyam Travels</h1>
          <p style={{ fontSize: "1.25rem", opacity: 0.85, fontWeight: "400" }}>
            Experience the world with India's most trusted travel partner.
          </p>
        </Container>
      </section>

      <Container>
        {/* --- MAIN CONTENT BENTO GRID --- */}
        <div style={styles.floatingCard}>
          <Row className="gy-5">
            <Col lg={7}>
              <h2 style={styles.sectionTitle}>About Our Legacy</h2>
              <div 
                className="modern-text-flow"
                style={{ fontSize: "1.1rem", lineHeight: "1.9", color: "#4a4a4a" ,
    wordBreak: "break-word",         // break long words
    overflowWrap: "break-word",      // safe fallback for word-break
    whiteSpace: "normal"             // ensure normal wrapping

                }}
                dangerouslySetInnerHTML={{ __html: webSettings?.aboutRadheshyamTravels }}
              />
              
              <div className="mt-5 p-4" style={{ background: "#f8f9fa", borderRadius: "20px" }}>
                 <h4 style={{ color: "#0a3b78", fontWeight: "700" }}>Services & Fleet</h4>
                 <div dangerouslySetInnerHTML={{ __html: webSettings?.servicesAndTransportation }} 
                     style={{
      wordBreak: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal"
    }}
                 />
              </div>
            </Col>

            <Col lg={5}>
              <div className="p-4" style={{ background: "#0a3b78", borderRadius: "24px", color: "#fff" }}>
                <h3 className="mb-4" style={{ fontWeight: "700" }}>Quick Connect</h3>
                
                <div className="d-flex mb-4 align-items-center">
                  <div className="me-3 p-3" style={{ background: "#333", borderRadius: "12px" }}><FaMapMarkerAlt /></div>
                  <small style={{ opacity: 0.8 }}>{office?.address}</small>
                </div>

                <div className="d-flex mb-4 align-items-center">
                  <div className="me-3 p-3" style={{ background: "#333", borderRadius: "12px" }}><FaPhoneAlt /></div>
                  <div>
                    <div style={{ fontSize: "0.8rem", opacity: 0.6 }}>Helpline</div>
                    <div className="fw-bold">{office?.phone}</div>
                  </div>
                </div>

                <div className="d-flex mb-4 align-items-center">
                  <div className="me-3 p-3" style={{ background: "#333", borderRadius: "12px" }}><FaEnvelope /></div>
                  <div style={{ fontSize: "0.9rem" }}>{office?.email}</div>
                </div>
 <div className="modern-socials mb-2 d-flex justify-content-center">
    {webSettings?.socialMedia?.map((item, index) => (
      <div
        key={index}
        className="social-box"
        onClick={() => window.open(item.link, "_blank")}
      >
        <Image  src={item.iconLink}  alt={item.type} className="social-icon"         style={{ width: "24px", height: "24px", objectFit: "contain" }}
 />
        
      </div>
    ))}
  </div>
                <a href={`https://${office?.websiteurl}`} className="btn btn-danger w-100 py-3 mt-2" style={{ borderRadius: "12px", fontWeight: "600", backgroundColor: "#e31e24" }}>
                  WhatsApp <FaGlobe className="ms-2" />
                </a>
              </div>
            </Col>
          </Row>
        </div>

        {/* --- CANCELLATION POLICY (MODERN LIST) --- */}
        <Row className="mt-5 pt-5 pb-5">
          <Col lg={6}>
            <h2 style={styles.sectionTitle}>Cancellation <span style={{ color: "#e31e24" }}>Policy</span></h2>
            <p className="text-muted mb-5">We believe in transparent and fair refund processes for our travelers.</p>
            
            {webSettings?.cancellationPolicy?.map((item, index) => (
              <div key={index} style={styles.policyPill} className="policy-hover">
                <div>
                  <span className="text-muted small">Timeline:</span>
                  <div className="fw-bold">{item.prior_of_day} Days</div>
                </div>
                <FaChevronRight style={{ color: "#ddd" }} />
                <div className="text-end">
                  <span className="text-muted small">Refundable:</span>
                  <div style={{ color: "#e31e24", fontWeight: "800", fontSize: "1.2rem" }}>{item.refundable}</div>
                </div>
              </div>
            ))}
          </Col>

          <Col lg={6}>
             <div className="h-100 p-5" style={{ border: "2px dashed #e0e0e0", borderRadius: "24px" }}>
                <h4 style={{ color: "#0a3b78", fontWeight: "700" }}>Important Remarks</h4>
                <div 
                  style={{ fontSize: "0.95rem", color: "#666" ,
  wordBreak: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal"

                  }}
                  dangerouslySetInnerHTML={{ __html: webSettings?.web_tours_remarks }} 
                />
             </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutUs;